"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitiateCheckoutCommand = void 0;
class InitiateCheckoutCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { value, contents } = this.input;
        const { gtag: googleAnalyst } = config;
        googleAnalyst('event', 'begin_checkout', {
            currency: 'VND',
            value: value,
            items: contents?.map(content => ({
                item_id: content.id,
                item_name: content.content_data?.name ?? 'no-name',
                google_business_vertical: 'retail'
            })) ?? []
        });
        return Promise.resolve();
    }
}
exports.InitiateCheckoutCommand = InitiateCheckoutCommand;
